export default {
  title: 'Sands Delivery Service',
  pathId: '',
  testShopifyId: 'gid://shopify/Product/7948306153561',
  prodShopifyId: 'gid://shopify/Product/8890965131500',
  description: '',
  shortDescription: '',
  isSoldOut: false,
  // TODO: Add the proper image
  primaryImg: {
    src: 'https://a.storyblok.com/f/152150/585x600/d2830b229a/fc-marketplace-accessory-kids-gloves-001.png',
    alt: 'Partner Workout Pack',
  },
  includes: [
    {
      productName: '300 lbs of easy-to-pour sand',
    },
    {
      productName: 'Large funnel to speed up the process ',
    },
  ],
};
